<script setup lang="ts">
import { useWebStore } from '~/store/web'

const webStore = useWebStore()

// Remount the active page when the selected web changes (toolbar switcher,
// ?webId= language jump) so per-web screens re-fetch instead of showing the
// previous web's data until a hard refresh.
const pageKey = computed(() => `web-${webStore.selectedWebsite?.id ?? 'none'}`)
</script>

<template>
  <NuxtLayout>
    <NuxtPage :key="pageKey" />
  </NuxtLayout>
  <!-- One Toast for the whole app (F115): a per-layout Toast unmounted with its
       layout, so „Vítejte zpět" after login (empty → default layout) only
       flickered. -->
  <Toast />
</template>
